import $ from "jquery";

$("#flexSwitchCheck").on('change', function () {
    $("body").toggleClass("light-mode");
    $("body").toggleClass("dark-mode");

    $(".navbar").toggleClass("navbar-light");
    $(".navbar").toggleClass("bg-light");

    $(".navbar").toggleClass("navbar-dark");
    $(".navbar").toggleClass("bg-dark");

    $(".footer-wrapper").toggleClass("bg-light");
    $(".footer-wrapper").toggleClass("bg-dark");
});